import type { FC } from 'react';

import classNames from 'classnames';

import * as styles from './Placeholder.module.scss';

export const placeholderTypes = {
  assetVertical: 'assetVertical',
  assetWithVerticalThumbnail: 'assetWithVerticalThumbnail',
  category: 'category',
  profile: 'profile',
  favourites: 'favourites',
  favouritesVertical: 'favouritesVertical',
  story: 'story',
} as const;

interface PlaceholderProps {
  type: keyof typeof placeholderTypes;
}

export const Placeholder: FC<PlaceholderProps> = ({ type }) => {
  if (type === placeholderTypes.favouritesVertical) {
    return (
      <div className={styles.favouritesVertical}>
        <div className={styles.thumbnailContainer}>
          <div className={styles.thumbnail}></div>
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.info}></div>
          <div className={styles.star}></div>
        </div>
      </div>
    );
  }

  if (type === placeholderTypes.story) {
    return (
      <div className={classNames(styles.container, styles.story)}>
        <div className={styles.thumbnail}>
          <div className={styles.title} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.container, {
        [styles.assetVertical]: type === placeholderTypes.assetVertical,
        [styles.assetWithVerticalThumbnail]:
          type === placeholderTypes.assetWithVerticalThumbnail,
        [styles.category]: type === placeholderTypes.category,
        [styles.profile]: type === placeholderTypes.profile,
        [styles.favourites]: type === placeholderTypes.favourites,
      })}
    >
      <div className={styles.thumbnail}>
        <div className={styles.duration} />
      </div>
      <div className={styles.title} />
      {type === placeholderTypes.favourites && (
        <div className={styles.favouritesContainer}>
          <div className={styles.favouritesTitle} />
          <div className={styles.favouritesStar} />
        </div>
      )}
      <div className={styles.details} />
    </div>
  );
};
